import axiosfiscal from "../apifiscal";
import { INFO_ERROR } from "./actions/infoError";
import { SPLICE_ERRO } from "./actions/alert_api";
let IssueNfeApplication = require("../application/Service/IssueNfe/IssueNfeApplication");
import axios from "axios";

const {
    CHECK_EMITER_NFE_REFERENCES,
    ISSUE_OF_INVOICE_NFE,
    GET_SEQUENCE_NFE,
    REPRINT_NFE_WITH_KEY,
} = require('./actions/nfe')

const moduleNfe  = {

    state: () => ({
        getNfeReferences: Object(),
        nfe: Object(),
        sequenceNfe: Object(),
        reprintnfe: Object(),
    }),
    mutations: {
        CHECK_EMITER_NFE_REFERENCES: (state, payload) => {
            state.getNfeReferences = payload
        },
        ISSUE_OF_INVOICE_NFE: (state, payload) => {
            state.nfe = payload
        },
        GET_SEQUENCE_NFE: (state, payload) => {
            state.sequenceNfe = payload
        },
        REPRINT_NFE_WITH_KEY: (state, payload) => {
            state.reprintnfe = payload
        },
    },
    actions: {
        async CHECK_EMITER_NFE_REFERENCES({ commit }, payload) {
            let token = localStorage.getItem("token_fiscal");
            return new Promise((resolve) => {
                axiosfiscal.post("/noteissue/getNfeReferences", payload, {
                    headers: { 'Authorization': 'Bearer ' + token }
                }).then((response) => {
                    resolve({ response })
                    commit(CHECK_EMITER_NFE_REFERENCES, response.data)
                }).catch((r) => {
                    commit(SPLICE_ERRO, {
                        alert: "Erro ao obter a validação da nfe emitida!",
                        type: 'E'
                    })
                })
            })
        },

        async ISSUE_OF_INVOICE_NFE({ commit }, payload) {
            let token = localStorage.getItem("token_fiscal");
            let nfe = await IssueNfeApplication.issueNfe(payload);
            return new Promise((resolve, reject) => {
                axiosfiscal.post("/noteissue/nfe", {
                    destinationNFe: nfe.destinationNFe,
                    emitterNFe: nfe.emitterNFe,
                    identifyNFe: nfe.identifyNFe,
                    productsNFe: nfe.productsNFe,
                    transportInfo: nfe.transportInfo,
                }, {
                    headers: { 'Authorization': 'Bearer ' + token }
                }).then((response) => {
                    resolve({ response });
                    commit(ISSUE_OF_INVOICE_NFE, response.data);
                    if (response.data.nfe && response.data.nfe.status === "Rejeitada") {
                        commit(INFO_ERROR, {
                            dialog: true,
                            title: "Erro ao emitir NFe - NFe Rejeitada",
                            menssage: "Verificar em Notas emitidas"
                        });
                    }
                }).catch((error) => {
                    reject({ error });
                    commit(INFO_ERROR, {
                        dialog: true,
                        title: error.response?.data?.[0] || "Erro ao emitir NFe",
                        menssage: error.response?.data?.menssagem || ""
                    });
                });
            });
        },

        REPRINT_NFE_WITH_KEY({ commit }, payload) {
            let token = localStorage.getItem("token_fiscal");
            return new Promise((resolve) => {
                axiosfiscal.post("/noteissue/nfereprintdanfe", payload, {
                    headers: { 'Authorization': 'Bearer ' + token }
                }).then((response) => {
                    resolve({ response })
                    commit(REPRINT_NFE_WITH_KEY, response.data)
                })
            })
        },

        GET_SEQUENCE_NFE({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios.post("noteModel/getSequenceTypeNfe", {
                    enterprise_id: payload.enterprise_id,
                    typeNoteModel: payload.typeNoteModel,
                }).then(({ data }) => {
                    resolve({ data });
                    commit(GET_SEQUENCE_NFE, data);
                }).catch((error) => {
                    reject({ error });
                    commit(INFO_ERROR, {
                        dialog: true,
                        title: "Erro ao obter a sequência de NFe",
                        menssage: "Sem comunicação com retaguarda"
                    });
                });
            });
        },
    },
    getters: {
        getNfeReferences: (state) => ({ ...state.getNfeReferences }),
        getIssuedNfe: (state) => ({ ...state.nfe }),
    }

}
export default moduleNfe

